import React from "react";
import "./index.scss";

const PolicyPage = ({ title, content }) => {
  return (
    <div className="policy-page">
      <div className="container">
        <h1>{title}</h1>
        <div
          className="policy-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default PolicyPage;
